import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import RssTextField from "../Blog/RssTextField";
import { getPodcastSession } from "../../utils";
import { Tabs } from "../../designSystem";

const TOPICS = [
  { id: "usage", label: "如何使用本站" },
  { id: "zsxq", label: "如何绑定知识星球" },
  { id: "rss", label: "如何使用 RSS 订阅" },
];

function UsageHelp({ podcastSession }) {
  return (
    <div className="lt-prose">
      <p>
        本站是边角聊播客订阅网站，提供了网页收听和 RSS
        收听两种模式，并且支持会员收听付费内容。需要收听付费内容，请至知识星球成为我们的付费会员并在本网站绑定知识星球账号。
      </p>
      <p>
        星球链接：
        <a href="https://t.zsxq.com/ciiAK" target="_blank" rel="noopener noreferrer">
          https://t.zsxq.com/ciiAK
        </a>
      </p>
      <p>您也可以使用微信扫描二维码，加入我们的知识星球：</p>
      <img src={`${process.env.PUBLIC_URL}/images/zsxq.jpg`} alt="知识星球二维码" />
      <h3>使用方法</h3>
      <p>1. 点击右上角的登录按钮，在登录页面选择注册，输入邮箱和密码完成注册；</p>
      <p>
        2. 注册后选择右上角的知识星球绑定，按照
        <Link to="/help/zsxq">「如何绑定知识星球」</Link>
        绑定好知识星球账号，绑定后您将获得一个独属于您的 RSS 链接；
      </p>
      <p>
        3. 您可以在首页直接收听所有付费节目，也可以将独属于您的 RSS
        链接绑定在播客客户端中进行收听，方法见
        <Link to="/help/rss">「如何使用 RSS 订阅」</Link>。
      </p>
      <RssTextField podcastSession={podcastSession} style={{ margin: "14px 0" }} />
      <p>不能收听付费节目的通用 RSS：</p>
      <img src={`${process.env.PUBLIC_URL}/images/public_rss_url.jpg`} alt="通用 RSS" />
      <p>收听付费节目的专属 RSS：</p>
      <img src={`${process.env.PUBLIC_URL}/images/private_rss_url.jpg`} alt="专属 RSS" />
      <p>4. 如果遇到任何问题，欢迎随时联系管理员微信：lalambdada</p>
    </div>
  );
}

function ZsxqHelp() {
  return (
    <div className="lt-prose">
      <p>首先打开知识星球，点击右上角「更多」按钮：</p>
      <img src={`${process.env.PUBLIC_URL}/images/zsxq_step1.jpg`} alt="知识星球更多按钮" />
      <p>页面中头像下面第一行就是用户昵称，第二行就是成员编号。</p>
      <img
        src={`${process.env.PUBLIC_URL}/images/zsxq_step2.jpg`}
        alt="知识星球用户昵称和成员编号"
      />
      <p>
        最后，将用户昵称和成员编号填入本站
        <Link to="/zsxq" target="_blank">
          知识星球绑定
        </Link>
        页面，点击「绑定」按钮即可。
      </p>
    </div>
  );
}

function RssHelp({ podcastSession }) {
  return (
    <div className="lt-prose">
      <p>在您的 RSS 阅读器中，选择添加新的订阅源，然后输入以下 URL：</p>
      <RssTextField podcastSession={podcastSession} style={{ margin: "14px 0" }} />
      <p>接下来，只需在泛用型播客客户端和 RSS 阅读器中导入这个链接即可。</p>
      <h3>苹果播客导入</h3>
      <p>打开苹果播客，选择资料库，接着选择右上角的 ・・・ 图标</p>
      <img src={`${process.env.PUBLIC_URL}/images/apple_step1.jpeg`} alt="苹果播客导入步骤1" />
      <p>选择导入 RSS 源，将刚刚复制的 RSS 链接粘贴进去，然后点击完成。</p>
      <img src={`${process.env.PUBLIC_URL}/images/apple_step2.jpeg`} alt="苹果播客导入步骤2" />
      <p>导入后，在资料库中就可以看到这个播客了。</p>
      <img src={`${process.env.PUBLIC_URL}/images/apple_step3.jpeg`} alt="苹果播客导入步骤3" />
      <h3>YouTube Music 导入（安卓和苹果平台均可使用）</h3>
      <p>打开 YouTube Music，点击媒体库，然后点击上方的播客图标，最后点击添加播客</p>
      <img
        src={`${process.env.PUBLIC_URL}/images/youtubemusic_step1.jpeg`}
        alt="YouTube Music 导入步骤1"
      />
      <p>将刚刚复制的 RSS 链接粘贴进去，然后点击完成。</p>
      <img
        src={`${process.env.PUBLIC_URL}/images/youtubemusic_step2.jpeg`}
        alt="YouTube Music 导入步骤2"
      />
      <p>导入后，在媒体库中就可以看到这个播客了。</p>
      <img
        src={`${process.env.PUBLIC_URL}/images/youtubemusic_step3.jpeg`}
        alt="YouTube Music 导入步骤3"
      />
      <h3>Pocket Casts（安卓和苹果平台均可使用）</h3>
      <p>1. 打开 Pocket Casts，在 App 上方搜索框粘贴刚才复制的 RSS 链接。</p>
      <img
        src={`${process.env.PUBLIC_URL}/images/pocketcasts_step1.jpeg`}
        alt="Pocket Casts 导入步骤1"
      />
      <p>2. 按输入法的回车键进行加载，加载完成即可看到订阅和收听播客。</p>
      <img
        src={`${process.env.PUBLIC_URL}/images/pocketcasts_step2.jpeg`}
        alt="Pocket Casts 导入步骤2"
      />
      <h3>其他支持 RSS 的播客客户端</h3>
      <p>市场上有大量泛用型播客客户端，这里不一一举例，请自行搜索教程。</p>
    </div>
  );
}

export default function HelpPage() {
  const navigate = useNavigate();
  const { topic } = useParams();
  const podcastSession = getPodcastSession();
  const activeId = TOPICS.some((t) => t.id === topic) ? topic : "usage";

  return (
    <div className="lt-main" style={{ maxWidth: 760 }}>
      <div className="lt-pagehead">
        <h1>帮助</h1>
        <p>使用本站、绑定会员、RSS 订阅的说明都在这里。</p>
      </div>
      <Tabs
        items={TOPICS}
        activeId={activeId}
        onChange={(id) => navigate(id === "usage" ? "/help" : `/help/${id}`)}
      />
      <div style={{ paddingTop: 20 }}>
        {activeId === "usage" ? <UsageHelp podcastSession={podcastSession} /> : null}
        {activeId === "zsxq" ? <ZsxqHelp /> : null}
        {activeId === "rss" ? <RssHelp podcastSession={podcastSession} /> : null}
      </div>
    </div>
  );
}
